import { PageHero } from "../components/common/PageHero";
import { CoreServicesGrid } from "../components/sections/CoreServicesGrid";
import { BpoSection } from "../components/sections/BpoSection";
import { ProcessTimeline } from "../components/sections/ProcessTimeline";
import { FinalCTA } from "../components/sections/FinalCTA";
import { images } from "../data/content";

export default function Services() {
    return (
        <>
            <PageHero
                overline="Our Core Services"
                breadcrumb="Services"
                title="Workforce & staffing services, end to end"
                subtitle="Contract staffing, temporary staffing, permanent recruitment, bulk hiring, payroll, on-site management, project-based staffing and facility management."
                image={images.warehouse}
            />
            <CoreServicesGrid />
            <BpoSection />
            <ProcessTimeline dark={false} />
            <FinalCTA />
        </>
    );
}
